import React from 'react'

import { accountStatusStringFromCode } from '../../../../utils/userUtils'
import LgyLink from '../../../../components/util/lgy-link/LgyLink'

// TODO: when page is narrow, use that CSS that appraiser gear has to pivot the table to fit
const SearchResults = ({ results }) =>
  <div className='search-results'>
    <table>
      <thead>
        <tr>
          <th scope='col'>Username</th>
          <th scope='col'>First Name</th>
          <th scope='col'>Middle Name</th>
          <th scope='col'>Last Name</th>
          <th scope='col'>SSN (Last Four)</th>
          <th scope='col'>Account Status</th>
        </tr>
      </thead>
      <tbody>
        {results.map(result =>
          <tr key={result.id}>
            <td><LgyLink to={`/lgyhub/admin/users/${result.id}`}>{result.portalId}</LgyLink></td>
            <td>{result.firstName}</td>
            <td>{result.middleName}</td>
            <td>{result.lastName}</td>
            <td>{result.ssn}</td>
            <td>{accountStatusStringFromCode(result.accountStatusCode)}</td>
          </tr>)}
      </tbody>
    </table>
  </div>

export default SearchResults